import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import fullTrustWalletLogo from "@/assets/full-trust-wallet-logo.webp";

type LegalPageLayoutProps = {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
};

const LegalPageLayout = ({ title, lastUpdated, children }: LegalPageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-50 border-b border-border/40 bg-background/90 backdrop-blur-xl">
        <div className="container flex h-20 items-center justify-between">
          <Link to="/" className="flex shrink-0 items-center" aria-label="Trust Wallet homepage">
            <img src={fullTrustWalletLogo} alt="Trust Wallet" className="h-[2.4rem] w-auto md:h-[2.7rem]" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </div>
      </header>

      <main className="container max-w-4xl py-16">
        <h1 className="text-4xl font-black tracking-[-0.04em] text-foreground sm:text-5xl">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated: {lastUpdated}</p>

        <div className="prose-legal mt-12 space-y-8 text-base leading-relaxed text-muted-foreground [&_h2]:mt-10 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:text-foreground [&_h3]:mt-6 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-foreground [&_li]:ml-6 [&_li]:list-disc [&_p]:mt-4 [&_ul]:mt-4 [&_ul]:space-y-2">
          {children}
        </div>
      </main>

      <footer className="border-t border-border/50">
        <div className="container py-8 text-center text-sm text-muted-foreground">
          © 2026 Trust Wallet Card. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default LegalPageLayout;
